import { langs } from "i18n-iso-countries";
import { getI18nCountries } from "./getI18nCountries";

describe("getI18nCountries", () => {
    langs().forEach((lang) => {
        it(`returns the correct i18n resource for [${lang}]`, async () => {
            const { locale, countries } = await getI18nCountries(lang);
            expect(locale).toEqual(lang);
            expect(Object.keys(countries).length).toEqual(250);
        });
    });

    it("returns the en fallback translations if an invalid language is passed in", async () => {
        const { locale, countries } = await getI18nCountries("XY");
        expect(locale).toEqual("en");
        expect(countries["AT"]).toEqual("Austria");
        expect(Object.keys(countries).length).toEqual(250);
    });

    it(`returns the en fallback translations if the locale format is invalid`, async () => {
        const { locale, countries } = await getI18nCountries("0");
        expect(locale).toEqual("en");
        expect(Object.keys(countries).length).toEqual(250);
    });
});
